import { Session } from '@ais-ui/auth';

export type Group = {
  name: string;
  share: boolean;
  uuid: string;
};

export const getShareGroups = async (session: Session): Promise<Group[]> => {
  const response = await session.request('getGroupDefinitions', {});

  response;

  if (Array.isArray(response)) {
    const sharedGroups = response.filter((group) => group.share === true);
    return sharedGroups;
  }

  return [];
};

export const getAllGroups = async (session: Session): Promise<Group[]> => {
  const response = await session.request('getGroupDefinitions', {});

  if (!response) {
    return [];
  }

  return response;
};
